export enum GovernmentSpecificity {
	Government = 'Government',
	GovernmentType = 'GovernmentType'
}
